/**
 * OrdinalBadge — the small numbered disc that marks position in a list.
 *
 * "Column 3", "Section 2" — a number in a sunken circle, sitting to the left
 * of the row it counts. The recipe was written out identically in three
 * template forms and had already drifted on weight, so it lives here.
 *
 * It is a COUNTER, not a heading: muted, `font-medium`, and never the loudest
 * thing in a row it exists to label.
 */
import React from 'react';
import clsx from 'clsx';

export interface OrdinalBadgeProps {
  /** 1-based, as the reader counts. */
  value: number;
  className?: string;
}

const OrdinalBadge: React.FC<OrdinalBadgeProps> = ({ value, className }) => (
  <span
    aria-hidden
    className={clsx(
      'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full',
      'border border-hairline-soft bg-surface-sunken',
      'text-xs font-medium text-fg-muted',
      className,
    )}
  >
    {value}
  </span>
);

export default OrdinalBadge;
